export default __webpack_public_path__ + "static/media/plaque-2.5834c960.jpg";